import { render, staticRenderFns } from "./BerkleyPolicyList.vue?vue&type=template&id=dc56fa5e"
import script from "./BerkleyPolicyList.vue?vue&type=script&lang=js"
export * from "./BerkleyPolicyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports